export const WHITE = '#fff';
export const PICTON_BLUE = '#3298f1';
export const PICTON_BLUE_TRANSPARENT = 'rgba(50, 152, 241, 0.7)';
export const SILVER = '#CCCCCC';
export const RED = '#d13a3a';
